import {sumBy} from 'lodash';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {getUserChannelImportJobs} from '../../../../store/data/jobs/jobsSelectors';
import {ChannelImportBanner} from './channelImportBanner';

/*
 * Selectors.
 */

/** Compute the overall progress of all of our user's channel import jobs. */
const getProgress = createSelector(getUserChannelImportJobs, (channelsBeingImported) => {
  // If there are no channel being imported, we're done.
  if (channelsBeingImported.length === 0) {
    return 1;
  }

  const completedStepCount = sumBy(channelsBeingImported, (c) => c.completedStepCount);
  const stepCount = sumBy(channelsBeingImported, (c) => c.stepCount);

  // If there are 0 steps, we're done.
  if (stepCount === 0) {
    return 1;
  }

  // Otherwise, compute the progress ratio.
  return completedStepCount / stepCount;
});

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  progress: getProgress,
}));

export const ChannelImportBannerContainer = connect(mapStateToProps)(ChannelImportBanner);
